import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import api from "@/lib/api";
import Seo from "@/components/Seo";

// Bilinmeyen adres: kayıtlı yönlendirme varsa oraya gider, yoksa 404 + noindex gösterir
export default function NotFoundPage() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const [target, setTarget] = useState(null);
  useEffect(() => {
    setState("checking");
    api.get("/redirects/resolve", { params: { path: pathname } })
      .then((r) => {
        if (r.data.yeni) { setTarget(r.data.yeni); setState("redirect"); navigate(r.data.yeni + search, { replace: true }); }
        else setState("404");
      })
      .catch(() => setState("404"));
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  if (state === "redirect") {
    return (
      <Helmet>
        <meta name="prerender-status-code" content="301" />
        <meta name="prerender-header" content={`Location: ${target}`} />
      </Helmet>
    );
  }
  if (state === "checking") return <div className="py-24" />;
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-20 text-center" data-testid="not-found-page">
      <Seo title="Sayfa bulunamadı | Molar Kimya" noindex status={404} />
      <p className="text-sm font-mono text-teal-700">404</p>
      <h1 className="font-head text-3xl font-bold text-slate-900 mt-2">Aradığınız sayfa bulunamadı</h1>
      <p className="text-slate-600 mt-3">Adres değişmiş veya kaldırılmış olabilir. Ürün kataloğunda arama yapabilir ya da bize ulaşabilirsiniz.</p>
      <div className="flex flex-wrap gap-3 justify-center mt-6">
        <Link to="/urunler" className="px-4 py-2 rounded-md bg-teal-600 text-white text-sm" data-testid="nf-catalog">Ürün kataloğu</Link>
        <Link to="/sektorler" className="px-4 py-2 rounded-md border text-sm" data-testid="nf-sectors">Sektörler</Link>
        <Link to="/teklif-iste" className="px-4 py-2 rounded-md border text-sm" data-testid="nf-quote">Teklif desteği</Link>
        <Link to="/iletisim" className="px-4 py-2 rounded-md border text-sm" data-testid="nf-contact">İletişim</Link>
      </div>
    </div>
  );
}
